import React from 'react'
import './cta.css'

const cta = () => {
  return (
    <div className="amill__cta-section  container">
      <div className="amill__cta-container">
        <div className="amill__cta-writeUpHolder">
          <p>Request Early Acess</p>
          <h2>Register Today and start sharing your stories with us</h2>
        </div>
        <button>Get started</button>
      </div>
    </div>
  )
}

export default cta
